import api from "../../../api";

export default {
  async getSettings({ commit }, query) {
    commit("REQUEST_SETTINGS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_SETTINGS",
        await api.getSettings(query)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_SETTINGS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deleteSetting({ commit }, id) {
    commit("REQUEST_DELETE_SETTING");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DELETE_SETTING",
        await api.deleteSetting(id)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_DELETE_SETTING");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateSetting({ commit }, item ) {
    commit("REQUEST_UPDATE_SETTING");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_SETTING",
        await api.updateSetting(item)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_UPDATE_SETTING");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createSetting({ commit }, item ) {
    commit("REQUEST_CREATE_SETTING");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_CREATE_SETTING",
        await api.createSetting( item )
      );
    } catch (err) {
      commit("FAILURE_REQUEST_CREATE_SETTING");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
